import axios from "axios";
import { jwtDecode } from "jwt-decode";
import tokenService from "./tokenService";

const axiosObject = axios.create();

// List of endpoints that do not require a token
const noAuthEndpoints = ["/auth/challenge",
     "/auth/confirm", "/auth/token"];

  axiosObject.interceptors.request.use(
  async (config) => {
    // Check if the request URL matches any endpoint in the noAuthEndpoints list
    const requiresAuth = !noAuthEndpoints.some((endpoint) =>
      config.url.includes(endpoint)
    );

    if (requiresAuth) {
      let token = tokenService.getAccessToken();
      if (token) {
        const tokenExpiry = jwtDecode(token).exp * 1000; // Decode the token to check expiration
        if (Date.now() > tokenExpiry) {
          token = await tokenService.refreshAccessToken();
        }
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosObject;
